import React from "react";
import MovimientoBase, { MovimientoBaseConfig } from "./MovimientoBase";

const config: MovimientoBaseConfig = {
  documentTitle: "Stock - Transferencias internas | Saas",
  breadcrumbTitle: "Transferencia interna",
  breadcrumbSection: "Stock",
  conceptoTitulo: "Transferencia interna",
  conceptoValor: "Transferencia interna",
  mostrarSeccionPersona: false,
  usarCabeceraDepositos: true,
  apiPath: "/api/stock/transferencias-internas",
};

const StockTransferenciasInternasPage: React.FC = () => <MovimientoBase config={config} />;

export default StockTransferenciasInternasPage;
